'use strict';

(function () {
    'use strict';

    angular.module('tutorialModal', ['ui.router', 'common']);
})();